<template>
  <div id="contenedor-licitaciones-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <v-tab
          :key="index"
          :to="{ name: opcion.ruta }"
          exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'LicitacionesOpcinesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Firmas',
          ruta: 'licitacionesConfiguracionFirmas',
          icono: '',
        },
        {
          nombre: 'Plantillas',
          ruta: 'licitacionesConfiguracionPlantillas',
          icono: '',
        },
        {
          nombre: 'Etiquetas',
          ruta: 'licitacionesConfiguracionEtiquetas',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
